import { isRef } from "#imports";
export default {
  get(v) {
    return isRef(v) ? v.value : v;
  },
  set(context, key, value) {
    if (isRef(context[key])) {
      context[key].value = value;
    } else {
      context[key] = value;
    }
  }
};
